module.exports = __webpack_public_path__ + "img/3.905f33ec.jpg";